import React from 'react';
import classNames from 'classnames';
import './SignUpLogo.pcss';
import logoLight from './mobilemonkey-logo.svg';
import logoDark from './mobilemonkey-logo-dark.png';

type Props = {
  className?: string;
  dark?: boolean;
};

export const SignUpLogo = ({ className, dark }: Props) => {
  return (
    <div className={classNames(className, 'sign-up-logo')}>
      <img
        className="sign-up-logo__image"
        alt="MobileMonkey Logo"
        src={dark ? logoDark : logoLight}
      />
    </div>
  );
};
